import { ROUTES } from "@/app/constants";
import type { UserRole } from "@/features/auth/types";

/**
 * Where a signed-in user should land based on their role.
 *
 * ADMIN / SUPER_ADMIN / STAFF (internal roles) go straight to Services
 * (`/services`) — changed 2026-07-16 from `/dashboard`, since the Dashboard
 * tab was dropped from the admin nav (dead placeholder page) and Services
 * is the real, most-used admin screen. CLIENT lands in the client portal
 * (`/portal`). Anything unrecognized falls back to the client portal —
 * safer than dropping an unknown role into the admin shell by default.
 *
 * Kept as a standalone module (not colocated in RoleGuard) so `GuestGuard`
 * and the root-path redirect can share the same decision without a
 * circular import.
 */
export function pickHomeForRole(role?: UserRole): string {
  switch (role) {
    case "ADMIN":
    case "SUPER_ADMIN":
    case "STAFF":
    case "admin":
    case "staff":
    case "manager":
      return ROUTES.Services;
    case "CLIENT":
    case "lead":
      return ROUTES.portal;
    default:
      return ROUTES.portal;
  }
}
